import { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import styles from './Search.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { usePage } from '../../hooks/usePage';

import { selectPublicIds } from '../../services/search';
import { menuChanged, selectMenu } from '../../features/infoSlice';
import {
  searchDetailsToggled,
  selectSearchOptions,
  selectSearchSelectedId,
  selectSearchWord,
} from '../../features/searchSlice';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';
import ListOption from '../../components/ListOption';
import List from '../../components/List';
import Details from '../../components/Details';
import { SHARING_LIBRARY } from '../../constants';

export default function Search() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const options = useAppSelector(selectSearchOptions);

  const { isDetailsOpened, isEditMode } = options;
  const { pageChanged } = usePage();

  const selectedId = useAppSelector(selectSearchSelectedId);
  const ids = useAppSelector(selectPublicIds);
  const searchWord = useAppSelector(selectSearchWord);

  const searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    dispatch(menuChanged('search'));
    menu === 'search' && dispatch(pageChanged(0));
  }, []);

  useEffect(() => {
    !ids.includes(selectedId) && dispatch(searchDetailsToggled(false));
  }, [ids]);

  if (menu !== 'search') return null;

  return (
    <Container isSubPage={true}>
      <TopArea
        title={SHARING_LIBRARY}
        className="st_subpage"
        ref={searchInputRef}
      />
      <div className={cx('content')}>
        <div className={cx('section')}>
          <h2 className="blind">{SHARING_LIBRARY}</h2>
          <ListOption />
          <div
            className={cx(
              'library_area',
              {
                'library--info-active': isDetailsOpened,
              },
              {
                'is--editing': isEditMode || searchWord,
              }
            )}
          >
            <List />
            {isDetailsOpened && <Details />}
          </div>
        </div>
      </div>
    </Container>
  );
}
